/* tslint:disable */

/* eslint-disable */

/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from "../runtime";
import {
  APIKey,
  APIKeyFromJSON,
  APIKeyFromJSONTyped,
  APIKeyToJSON,
} from "./APIKey";

/**
 *
 * @export
 * @interface APIKeyFetchResponse
 */
export interface APIKeyFetchResponse {
  /**
   *
   * @type {APIKey}
   * @memberof APIKeyFetchResponse
   */
  data: APIKey;
}

export function APIKeyFetchResponseFromJSON(json: any): APIKeyFetchResponse {
  return APIKeyFetchResponseFromJSONTyped(json, false);
}

export function APIKeyFetchResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): APIKeyFetchResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: APIKeyFromJSON(json["data"]),
  };
}

export function APIKeyFetchResponseToJSON(
  value?: APIKeyFetchResponse | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data: APIKeyToJSON(value.data),
  };
}
